import ProjectDateValidator from "Validators/Admin/ProjectDate";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";
import { useFormSchema } from "Hooks/useFormSchema";

import Button from "Components/Admin/Buttons";
import Checkbox from "Components/Admin/Form/Checkbox";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";

import * as S from "./styles";

const CalendarForm = ({
  projectId,
  selectedDate,
  setSelectedDate,
  getProjectDates,
}) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const [sponsorCanSee, setSponsorCanSee] = useState(null);
  const [proponentCanSee, setProponentCanSee] = useState(null);

  useEffect(() => {
    if (!selectedDate?.id) return;

    setSponsorCanSee(selectedDate.sponsor_can_see);
    setProponentCanSee(selectedDate.proponent_can_see);
  }, [selectedDate]);

  const methods = useFormSchema(ProjectDateValidator, {
    defaultValues: {
      name: selectedDate?.name,
      date: moment(selectedDate?.date).format("YYYY-MM-DD"),
      // Linha legada sem término (D5): NA EDIÇÃO pré-preenche com o início
      // (evento de 1 dia) para não travar no campo agora obrigatório. No
      // CRIAR fica vazio — moment(undefined) viraria HOJE e mascararia a
      // obrigatoriedade do término.
      finish_date: selectedDate?.id
        ? moment(selectedDate?.finish_date || selectedDate?.date).format(
            "YYYY-MM-DD",
          )
        : "",
    },
  });

  const { register, reset } = methods;

  const submit = async (data) => {
    setLoading(true);

    try {
      const route = selectedDate?.id
        ? "/projects/dates/update"
        : "/projects/dates/create";

      await api.post(route, {
        ...data,
        date_id: selectedDate?.id,
        project_id: projectId,
        sponsor_can_see: sponsorCanSee || false,
        proponent_can_see: proponentCanSee || false,
      });

      setLoading(false);

      showNotification("success", "Sucesso!", "Data atualizada com sucesso!");

      reset();
      setSelectedDate(null);
      getProjectDates(projectId);
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      <S.Modal>
        <FormWrapper {...methods} submit={submit}>
          <S.Section>
            <span>{selectedDate?.id ? "Atualizar" : "Cadastrar"}</span>
            <hr />
          </S.Section>

          <Input
            {...register("name")}
            label="Nome"
            placeholder="Nome da data"
            required
          />
          <Input
            {...register("date")}
            label="Data de início"
            type="date"
            placeholder="Data de início"
            required
          />
          <Input
            {...register("finish_date")}
            label="Data de término"
            type="date"
            placeholder="Data de término"
            required
          />

          <Checkbox
            name="sponsor_can_see"
            label="Patrocinador pode ver"
            placeholder="Patrocinador pode ver"
            defaultChecked={sponsorCanSee}
            checked={sponsorCanSee}
            onChange={(e) => setSponsorCanSee(e.target.checked)}
          />

          <Checkbox
            name="proponent_can_see"
            label="Proponente pode ver"
            placeholder="Proponente pode ver"
            defaultChecked={proponentCanSee}
            checked={proponentCanSee}
            onChange={(e) => setProponentCanSee(e.target.checked)}
          />

          <S.Buttons>
            <Button
              type="button"
              outline
              text="Fechar"
              disabled={loading}
              onClick={() => setSelectedDate(null)}
            />

            <Button
              type="submit"
              text={selectedDate?.id ? "Atualizar" : "Cadastrar"}
              disabled={loading}
            />
          </S.Buttons>
        </FormWrapper>
      </S.Modal>
    </S.Wrapper>
  );
};

export default CalendarForm;
